import React from 'react';
import {Link} from 'react-router-dom';

function Sellers(){

	return(
	
		<>

<div class="container">
{/* <!-- top sellers --> */}
<section class="row row--grid">
				{/* <!-- title --> */}
				<div class="col-12">
					<div class="main__title">
						<h2>Top sellers</h2>

						<Link to="/authors" class="main__link">View all <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></Link>
					</div>
				</div>
				{/* <!-- end title --> */}

{/* <!-- sellers list --> */}
				<div class="col-12">
					<ul class="sellers-list">
						<li>
							<span class="sellers-list__number">1</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller1.jpg" alt="" />
								<Link to="/author">@miriuuu</Link>
								<span>214.22 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">2</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller2.jpg" alt="" />
								<Link to="/author">@sc00ty</Link>
								<span>205.8 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">3</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller3.jpg" alt="" />
								<Link to="/author">@redalert</Link>
								<span>137.65 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">4</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller4.jpg" alt="" />
								<Link to="/author">@1one</Link>
								<span>129.301 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">5</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller5.jpg" alt="" />
								<Link to="/author">@kateblank</Link>
								<span>112.3 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">6</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller6.jpg" alt="" />
								<Link to="/author">@johndoe</Link>
								<span>108.88 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">7</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller7.jpg" alt="" />
								<Link to="/author">@nickname</Link>
								<span>88.58 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">8</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller8.jpg" alt="" />
								<Link to="/author">@lllily</Link>
								<span>73.207 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">9</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller9.jpg" alt="" />
								<Link to="/author">@fantraingle</Link>
								<span>71.076 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">10</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller10.jpg" alt="" />
								<Link to="/author">@oxyoxyoxy</Link>
								<span>57.041 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">11</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller11.jpg" alt="" />
								<Link to="/author">@vandam</Link>
								<span>50.261 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">12</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller12.jpg" alt="" />
								<Link to="/author">@dididi</Link>
								<span>44.79 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">13</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller13.jpg" alt="" />
								<Link to="/author">@lyzzy</Link>
								<span>43.24 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">14</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller14.jpg" alt="" />
								<Link to="/author">@oceanu</Link>
								<span>41.221 ETH</span>
							</div>
						</li>

						<li>
							<span class="sellers-list__number">15</span>
							<div class="sellers-list__author sellers-list__author--verified">
								<img src="/images/seller15.jpg" alt="" />
								<Link to="/author">@justart</Link>
								<span>40.195 ETH</span>
							</div>
						</li>
					</ul>
				</div>
				{/* <!-- end sellers list --> */}
			</section>
			{/* <!-- end top sellers --> */}

            </div>
            </>

);


}

export default Sellers;